import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from '../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';

const defaultSorted = [{ dataField: 'code', order: 'desc' }];
const List = (props) => {
  const { entities, totalCount, intl, setQueryParams, listLoading } = props;
  const finDateLabel = intl.formatMessage({ id: 'FINANCE.LABEL.FINDATE' });
  const saleAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.SALESAMOUNT',
  });
  const profitAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.PROFITAMOUNT',
  });
  const lostAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.LOSTAMOUNT',
  });
  const preOrderAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.PREORDERAMOUNT',
  });
  const shipAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.SHIPAMOUNT',
  });
  const deliveredAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.DELIVEREDAMOUNT',
  });
  const acnt1BalanceLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.ACNT1BALANCE',
  });
  const acnt2BalanceLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.ACNT2BALANCE',
  });

  // Table columns
  const columns = [
    {
      dataField: 'finDate',
      text: finDateLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.DateColumnFormatter,
    },
    {
      dataField: 'salesAmount',
      text: saleAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-primary',
    },
    {
      dataField: 'profitAmount',
      text: profitAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-success',
    },
    {
      dataField: 'lostAmount',
      text: lostAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      classes: 'text-center',
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-danger',
    },
    {
      dataField: 'preOrderAmount',
      text: preOrderAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-warning',
    },
    {
      dataField: 'shipAmount',
      text: shipAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-info',
    },
    {
      dataField: 'deliveredAmount',
      text: deliveredAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-success',
    },
    {
      dataField: 'acnt1Balance',
      text: acnt1BalanceLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-dark',
    },
    {
      dataField: 'acnt2Balance',
      text: acnt2BalanceLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-dark',
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPage: 400,
    page: 1,
  };
  return (
    <BootstrapTable
      key='financeSalesList'
      wrapperClasses='table-responsive'
      bordered={true}
      classes='table table-head-custom table-vertical-center overflow-hidden'
      bootstrap4
      remote
      keyField='code'
      data={entities === null ? [] : entities}
      columns={columns}
      defaultSorted={defaultSorted}
      onTableChange={getHandlerTableChange(setQueryParams)}
    >
      <PleaseWaitMessage entities={entities} />
      <NoRecordsFoundMessage entities={entities} />
    </BootstrapTable>
  );
};

export default injectIntl(List);
